import * as React from 'react'
import Icon from '@mui/icons-material/Domain'

import { ComponentWithSubheader } from 'dash/shared'
import { SettingsEdit } from './edit'

export default class Settings {
  static Edit = () => {
    return <ComponentWithSubheader path={['My Account', 'Settings']} label="Edit Settings" component={SettingsEdit} />
  }

  static Icon = Icon
}
